import { render, staticRenderFns } from "./overview-loading.vue?vue&type=template&id=a3972272"
import script from "./overview-loading.vue?vue&type=script&lang=js"
export * from "./overview-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports